import AddIcon from '@mui/icons-material/Add';
import { Button, useTheme } from '@mui/material';
import React from 'react';

import { CONTROL_FONT_SIZE, GROUP_GAP, secondaryButtonSx, SLOT_GAP } from './filterBarStyles';

export interface FilterBarAddFilterButtonProps {
  onClick: () => void;
}

/** Opens the Add Filter modal, and marks where the filter slots end and the
 *  actions on them begin. Split out of `FilterBar` to keep it inside the
 *  project's 250-line file budget. */
export const FilterBarAddFilterButton: React.FC<FilterBarAddFilterButtonProps> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Button
      startIcon={<AddIcon sx={{ fontSize: 15 }} />}
      onClick={onClick}
      aria-label="Add advanced filter"
      sx={{
        ...secondaryButtonSx(theme),
        fontSize: CONTROL_FONT_SIZE,
        // Opens the space between "what you are filtering on" and "what you do
        // about it" without drawing a rule that a wrapped row would strand
        // mid-line.
        ml: GROUP_GAP - SLOT_GAP,
      }}
    >
      Add Filter
    </Button>
  );
};
